import { useQuery } from 'react-query';

import { axios } from 'lib';

const getSupplierLotRates = (frameworkAgreementId, lotId, facId) => {
  return axios.get(
    `/api/framework_agreements/${frameworkAgreementId}/rates/lots/${lotId}/suppliers/${facId}`
  );
};

export const useSupplierLotRates = (frameworkAgreementId, lotId, facId, options = {}) => {
  return useQuery(
    `framework_agreements-${frameworkAgreementId}-rates-lots-${lotId}-suppliers-${facId}`,
    () => getSupplierLotRates(frameworkAgreementId, lotId, facId),
    {
      //@ts-ignore
      initialData: { data: { data: { exclusions: [], rates: [] } } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
